export default "__VITE_ASSET__B9euaS4T__"